import * as React from 'react';
import {
    Checkbox as ThemeCheckbox,
    Label
} from '@theme-ui/components';
// import {
//     StyledCheckboxContainer,
//     StyledCheckbox,
//     StyledInput
// } from './Checkbox.style'
// import { Box } from '../box'
// import { Icon } from '../icon'

// prevents clicking on the label trigging the event twice
// https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
const stopLabelClick = (e: any) => {
    if (e.target.type !== 'checkbox') {
        e.stopPropagation();
    }
};

type CheckboxProps = any & {}

const Checkbox: React.FC<CheckboxProps> = (props: any): React.ReactElement => (
    <Label {...props}>
        <ThemeCheckbox {...props}/>
        {props.label}
    </Label>
);

export default Checkbox;

// type Props = {
//     checked?: boolean
//     disabled?: boolean
//     focus?: any
//     id?: string
//     label?: string
//     name?: string
//     size?: number
//     theme?: any
//     toggle?: boolean
//     onChange?: (e: React.FormEvent) => void
// }

// class Checkbox extends React.Component<Props> {

//     static defaultProps = {
//         size: 20
//     }

//     render() {
//         const {
//             checked,
//             disabled,
//             focus,
//             id,
//             label,
//             name,
//             size,
//             theme,
//             toggle,
//             onChange,
//             ...rest
//         } = this.props

//         const adjustedSize = size + 4

//         return (
//             <StyledCheckboxContainer>
//                 <StyledCheckbox
//                     theme={theme}
//                     disabled={disabled}
//                 >
//                     <StyledInput type="checkbox" {...rest} role="checkbox" />
//                     <Icon name="box-checked" data-name="checked" size={adjustedSize} />
//                     <Icon name="box-empty" data-name="empty" size={adjustedSize} />
//                 </StyledCheckbox>
//                 {typeof label === 'string' ? <span>{label}</span> : label}
//             </StyledCheckboxContainer>
//         )

//     }
// }

// export { Checkbox }
